function checkUrl(url) {
  let res = url.slice(0, 4);
  return res === "http";
}
export default checkUrl;
